export default "__VITE_ASSET__BwTW$09k__"